import { render } from "./FishBookEntryLeasing.vue?vue&type=template&id=58945644&scoped=true&ts=true"
import script from "./FishBookEntryLeasing.vue?vue&type=script&lang=ts"
export * from "./FishBookEntryLeasing.vue?vue&type=script&lang=ts"

import "./FishBookEntryLeasing.vue?vue&type=style&index=0&id=58945644&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58945644"]])

export default __exports__